export default __webpack_public_path__ + "static/Template-ffd8b9559c4a873b12d34d85051f431b.mp4";